/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_F2Inputs */

const en_cp_mock_f2 = /** @type {(inputs: Cp_Mock_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue numbers & calling`)
};

const id_cp_mock_f2 = /** @type {(inputs: Cp_Mock_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor antrean & panggilan`)
};

/**
* | output |
* | --- |
* | "Queue numbers & calling" |
*
* @param {Cp_Mock_F2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_f2 = /** @type {((inputs?: Cp_Mock_F2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_F2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_f2(inputs)
	return en_cp_mock_f2(inputs)
});